import { render, staticRenderFns } from "./RoomSiteCard.vue?vue&type=template&id=b30b55b2&scoped=true&"
import script from "./RoomSiteCard.vue?vue&type=script&lang=js&"
export * from "./RoomSiteCard.vue?vue&type=script&lang=js&"
import style0 from "./RoomSiteCard.vue?vue&type=style&index=0&id=b30b55b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30b55b2",
  null
  
)

export default component.exports